import { render, staticRenderFns } from "./SettingsAttachmentsFolder.vue?vue&type=template&id=da87cab8&scoped=true"
import script from "./SettingsAttachmentsFolder.vue?vue&type=script&lang=js"
export * from "./SettingsAttachmentsFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da87cab8",
  null
  
)

export default component.exports